import React, { useEffect, useState } from "react";
import { useCustomContext } from "../../../state/CustomContext";
import { callAPIForQuery } from "../../../utilities/service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { cloneDeep } from "lodash";

const AmbulanceCreate: React.FC = () => {
    const context = useCustomContext();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { state } = context;

    const [hospitals, setHospitals] = useState([]);
    const [branches, setBranches] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [operatingHours, setOperatingHours] = useState([]);

    const [formData, setFormData] = useState<any>({
        id: -1,
        code: "",
        name: "",
        vehicle_number: "",
        ambulance_vehicle_type_id: "",
        ambulance_operating_hours_id: "",
        from_time: "",
        to_time: "",
        regulatory_certification: "",
        insurance_number: "",
        hospital_id: "",
        branch_id: "",
        isactive: "1",
        created_by: state?.user_id || "",
    });

    const [errors, setErrors] = useState<any>({});

    const getAmbulance = async (id: any) => {
        const response = await callAPIForQuery({ input: JSON.stringify({ id }), type: "get_ambulance" }, "post");
        if (response?.[0]?.[0]) {
            const formDataCopy = cloneDeep(formData);
            Object.keys(response[0][0]).forEach((key) => {
                formDataCopy[key] = response[0][0][key];
            });
            setFormData(formDataCopy);
        } else {
            alert("Invalid request. Please contact your administrator");
        }
    };

    const fetchDropdownData = async () => {
        const hospitalsResponse = await callAPIForQuery({ type: "get_hospitals" }, "post");
        const branchesResponse = await callAPIForQuery({ type: "get_branches" }, "post");
        const vehicleTypesResponse = await callAPIForQuery({ type: "get_vehicle_types" }, "post");
        const operatingHoursResponse = await callAPIForQuery({ type: "get_operating_hours" }, "post");

        setHospitals(hospitalsResponse || []);
        setBranches(branchesResponse || []);
        setVehicleTypes(vehicleTypesResponse || []);
        setOperatingHours(operatingHoursResponse || []);
    };

    useEffect(() => {
        const id = searchParams.get("id");
        if (id) getAmbulance(Number(id));
        fetchDropdownData();
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (e: any) => {
        setFormData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
        setErrors((prev: any) => ({ ...prev, [e.target.name]: "" }));
    };

    const validateForm = () => {
        let valid = true;
        let newErrors: any = {};
        ["code", "name", "vehicle_number", "ambulance_vehicle_type_id", "ambulance_operating_hours_id", "from_time", "to_time", "insurance_number", "hospital_id", "branch_id"].forEach(field => {
            if (!formData[field].toString().trim()) {
                newErrors[field] = `${field.replace(/_/g, ' ')} is required`;
                valid = false;
            }
        });
        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        try {
            const response = await callAPIForQuery({ input: JSON.stringify(formData), type: "sp_insert_update_ambulance" }, "post");
            if (response.error) {
                alert("Some error occurred");
            } else {
                alert("Ambulance saved successfully");
                navigate("/ambulance-view");
            }
        } catch (error) {
            console.error("Error saving ambulance:", error);
            alert("Failed to save ambulance.");
        }
    };

    return (
        <>
            <div className="row">
                {
                    errors && (<div>Some Error Occurred</div>)
                }
                {Object.keys(formData).filter(field => field !== "id" && field !== "created_by").map(field => (
                    <div key={field} className="form-option col-lg-3 mb-3">
                        <label className="field-title">{field.replace(/_/g, ' ')}</label>
                        {field === "hospital_id" || field === "branch_id" || field === "ambulance_vehicle_type_id" || field === "ambulance_operating_hours_id" || field === "isactive" ? (
                            <select name={field} value={formData[field]} onChange={handleChange} className="form-control">
                                {field === "isactive" ? (
                                    <>
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </>
                                ) : (
                                    (field === "hospital_id" ? hospitals : field === "branch_id" ? branches : field === "ambulance_vehicle_type_id" ? vehicleTypes : operatingHours).map((option: any) => (
                                        <option key={option.id} value={option.id}>{option.name}</option>
                                    ))
                                )}
                            </select>
                        ) : (
                            <input type="text" name={field} value={formData[field]} onChange={handleChange} className="form-control" />
                        )}
                    </div>
                ))}
            </div>
            <input type="hidden" name="created_by" value={formData.created_by} />
            <div className="action-set">
                <div>
                    <input onClick={handleSubmit} type="button" className="form-control" value={formData.id > 0 ? "Update" : "Save"} />
                </div>
            </div>
        </>
    );
};

export default AmbulanceCreate;
